function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { StyledShortHeaderMenuComponent } from "./short-header-menu-component.scss";
import { withGenericConfig } from "contexts/generic-config-context";
import ActionBar from "./action-bar/action-bar";
import { ProductsMenuComponent, ResourcesMenuComponent, SolutionsMenuComponent } from "./menus/index.js";
import { PRODUCTS_MENU_ID, RESOURCES_MENU_ID, SOLUTIONS_MENU_ID } from "segments/desktop/header/layouts/base-header/base-header-service";
import { fireGtmEvent } from "client/services/gtm-service/gtm-service";
import DataLayerEventTypes from "constants/data-layer-event-types";
import { MENU_ID_TO_EVENT_KIND_MAP } from "segments/desktop/header/layouts/base-header/base-header-desktop/consts";
import { trackEvent } from "services/bigbrain-service";
import { HEADER_SUBMENU_LINK_CLICKED } from "constants/bigbrain-event-types";
const ID_TO_MENU = {
    [RESOURCES_MENU_ID]: (props)=>/*#__PURE__*/ _jsx(ResourcesMenuComponent, _object_spread({
            menuId: RESOURCES_MENU_ID
        }, props)),
    [SOLUTIONS_MENU_ID]: (props)=>/*#__PURE__*/ _jsx(SolutionsMenuComponent, _object_spread({
            menuId: SOLUTIONS_MENU_ID
        }, props)),
    [PRODUCTS_MENU_ID]: (props)=>/*#__PURE__*/ _jsx(ProductsMenuComponent, _object_spread({
            menuId: PRODUCTS_MENU_ID
        }, props))
};
const ShortHeaderMenuComponent = ({ translate, menuId, localeId })=>{
    const onLinkClick = ({ menuId, text, event, link })=>{
        const isKeyboardEvent = (event === null || event === void 0 ? void 0 : event.screenX) === 0 && (event === null || event === void 0 ? void 0 : event.screenY) === 0;
        fireGtmEvent(DataLayerEventTypes.CLICK_MAIN_NAV, {
            click_text: translate(text),
            parent_category: MENU_ID_TO_EVENT_KIND_MAP[menuId]
        });
        trackEvent(HEADER_SUBMENU_LINK_CLICKED, {
            kind: link,
            info1: isKeyboardEvent ? "keyboard" : "mouse",
            info2: menuId
        });
    };
    return /*#__PURE__*/ _jsxs(StyledShortHeaderMenuComponent, {
        className: "short-header-menu-component",
        children: [
            ID_TO_MENU[menuId]({
                translate,
                onLinkClick,
                localeId
            }),
            /*#__PURE__*/ _jsx(ActionBar, {
                translate: translate
            })
        ]
    });
};
export default withGenericConfig(ShortHeaderMenuComponent);
